import { render } from "./inventoryHome.vue?vue&type=template&id=9fe013dc&scoped=true"
import script from "./inventoryHome.vue?vue&type=script&lang=js"
export * from "./inventoryHome.vue?vue&type=script&lang=js"

import "./inventoryHome.vue?vue&type=style&index=0&id=9fe013dc&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fe013dc"]])

export default __exports__